/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductPackageItem } from './productPackageItem';
import { AddDiscountRequest } from './addDiscountRequest';


export interface ProductPackage { 
    id?: number;
    name?: string;
    description?: string;
    packageType?: ProductPackage.PackageTypeEnum;
    active?: boolean;
    createdAt?: string;
    updatedAt?: string;
    items?: Array<ProductPackageItem>;
    discounts?: Array<AddDiscountRequest>;
    readonly finalTotal?: number;
    readonly totalDiscounts?: number;
    readonly grossTotal?: number;
}
export namespace ProductPackage {
    export type PackageTypeEnum = 'SUBSCRIPTION_PROVIDER_PF_FREE' | 'SUBSCRIPTION_PROVIDER_PF_BASIC' | 'SUBSCRIPTION_LAB_FREE' | 'SUBSCRIPTION_LAB_BASIC' | 'SUBSCRIPTION_PROVIDER_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_PJ_2' | 'SUBSCRIPTION_PROVIDER_PJ_6' | 'SUBSCRIPTION_PROVIDER_PJ_10' | 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' | 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_CONTRACTOR_PJ_120' | 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' | 'SUBSCRIPTION_ADMINISTRATOR';
    export const PackageTypeEnum = {
        ProviderPfFree: 'SUBSCRIPTION_PROVIDER_PF_FREE' as PackageTypeEnum,
        ProviderPfBasic: 'SUBSCRIPTION_PROVIDER_PF_BASIC' as PackageTypeEnum,
        LabFree: 'SUBSCRIPTION_LAB_FREE' as PackageTypeEnum,
        LabBasic: 'SUBSCRIPTION_LAB_BASIC' as PackageTypeEnum,
        ProviderPjFree: 'SUBSCRIPTION_PROVIDER_PJ_FREE' as PackageTypeEnum,
        ProviderPj2: 'SUBSCRIPTION_PROVIDER_PJ_2' as PackageTypeEnum,
        ProviderPj6: 'SUBSCRIPTION_PROVIDER_PJ_6' as PackageTypeEnum,
        ProviderPj10: 'SUBSCRIPTION_PROVIDER_PJ_10' as PackageTypeEnum,
        ProviderPjPersonal: 'SUBSCRIPTION_PROVIDER_PJ_PERSONAL' as PackageTypeEnum,
        ProviderContractorPjFree: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE' as PackageTypeEnum,
        ProviderContractorPj100: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100' as PackageTypeEnum,
        ProviderContractorPjPersonal: 'SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        ContractorPj120: 'SUBSCRIPTION_CONTRACTOR_PJ_120' as PackageTypeEnum,
        ContractorPjPersonal: 'SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL' as PackageTypeEnum,
        Administrator: 'SUBSCRIPTION_ADMINISTRATOR' as PackageTypeEnum
    };
}


